export const BULK_DOWNLOAD_STARTED = (userId: string) => {
  return {
    eventType: 'bulk-download-started',
    channelName: `user-${userId}`
  };
};

export const BULK_DOWNLOAD_SUCCESS = (userId: string) => {
  return {
    eventType: 'bulk-download-success',
    channelName: `user-${userId}`
  };
};

export const BULK_DOWNLOAD_FAILED = (userId: string) => {
  return {
    eventType: 'bulk-download-failed',
    channelName: `user-${userId}`
  };
};
